















































































import Vue from "vue";
import SpecialDimensionFilterValue, {
  emptySpecialDimensionFilter as emptyFilter,
} from "@/modules/specialDimension/models/SpecialDimensionFilter";

interface Data {
  menuOpen: boolean;
  draft: SpecialDimensionFilterValue;
}

interface Methods {
  clearDraft(): void;
  cancel(): void;
  apply(): void;
}

interface Computed {
  /** A 4 beégetett dimenzió sor-definíciója (K2D w_specdim feliratok). */
  rows: { name: string; from: keyof SpecialDimensionFilterValue; to: keyof SpecialDimensionFilterValue }[];
  /** Van-e ÉRVÉNYES (alkalmazott) szűrő — ettől sárga a szűrő-ikon (K2D filter_yellow). */
  active: boolean;
  draftHasValue: boolean;
}

interface Props {
  value: SpecialDimensionFilterValue;
  label: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    /** Az alkalmazott szűrő (v-model) — a szülő ebből építi a keresés-payloadot. */
    value: { type: Object as () => SpecialDimensionFilterValue, default: emptyFilter },
    /** A szöveges gomb felirata */
    label: { type: String, default: "Spec. dimenzió szűrő" },
  },

  data(): Data {
    return {
      menuOpen: false,
      draft: emptyFilter(),
    };
  },

  computed: {
    rows() {
      return [
        { name: "Munkaszám", from: "from1" as const, to: "to1" as const },
        { name: "Gépjármű", from: "from2" as const, to: "to2" as const },
        { name: "Szerelő", from: "from3" as const, to: "to3" as const },
        { name: "Szerviztípus", from: "from4" as const, to: "to4" as const },
      ];
    },

    active(): boolean {
      const v = this.value || emptyFilter();
      return Object.values(v).some((x) => !!(x || "").trim());
    },

    draftHasValue(): boolean {
      return Object.values(this.draft).some((x) => !!(x || "").trim());
    },
  },

  watch: {
    menuOpen(open: boolean) {
      if (open) {
        // K2D w_specdim open: a popup az aktuálisan alkalmazott értékekkel nyílik.
        this.draft = { ...emptyFilter(), ...(this.value || {}) };
      }
    },
  },

  methods: {
    /** K2D pb_clear: csak a popup mezőit üríti, az alkalmazott szűrőt nem. */
    clearDraft() {
      this.draft = emptyFilter();
    },

    /** K2D pb_cancel: bezár, az alkalmazott szűrő változatlan marad. */
    cancel() {
      this.menuOpen = false;
    },

    /** K2D pb_ok: az értékek visszaadása a szülőnek + szűrés indítása. */
    apply() {
      const result = emptyFilter();
      (Object.keys(result) as (keyof SpecialDimensionFilterValue)[]).forEach((k) => {
        result[k] = (this.draft[k] || "").trim();
      });
      this.$emit("input", result);
      this.$emit("apply");
      this.menuOpen = false;
    },
  },
});
